var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5363 7.60325H9.55549V11.3023H14.555C14.1051 12.5035 13.2508 13.5069 12.1572 14.1478C11.3337 14.6313 10.3742 14.9083 9.3498 14.9083C6.96669 14.9083 4.93384 13.4082 4.14422 11.3008C3.91596 10.6941 3.79178 10.0364 3.79178 9.35011C3.79178 8.71759 3.8977 8.10986 4.09163 7.54373C4.84181 5.3608 6.91262 3.79215 9.34948 3.79215C10.4286 3.79215 11.4364 4.10003 12.2884 4.63253L15.3173 2.15265C13.6985 0.808243 11.6182 0 9.3498 0C5.73624 0 2.6015 2.04965 1.04528 5.04998C0.376922 6.33745 0 7.79944 0 9.3498C0 10.9001 0.40321 12.4619 1.11431 13.7807C2.69355 16.7095 5.78921 18.6996 9.3498 18.6996C11.5657 18.6996 13.601 17.929 15.2032 16.6412C16.8508 15.3168 18.04 13.4455 18.495 11.3019C18.6292 10.6723 18.6996 10.0192 18.6996 9.3498C18.6996 8.75266 18.6437 8.16861 18.5363 7.60325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.53370c122b4e2e952436a121dc279536.svg";
export { ForwardRef as ReactComponent };